/**
 * Rabet `GET .../master-data/cities/search` — same contract as `/api/geocode/city`.
 */
export type RabetCityCoordsResult = {
  ok: boolean;
  latitude?: string;
  longitude?: string;
  message?: string;
};

export async function fetchRabetCityCoords(
  cityName: string
): Promise<RabetCityCoordsResult> {
  const base = process.env.NEXT_PUBLIC_RABET_BASE_URL?.trim();
  const city = cityName.trim();
  if (!city) {
    return { ok: false, message: "city is required" };
  }
  if (!base) {
    return { ok: false, message: "Base url needed for Rabet" };
  }
  const url = new URL(
    `${base.replace(/\/$/, "")}/master-data/cities/search`
  );
  url.searchParams.set("language", "en");
  url.searchParams.set("city", city);
  try {
    const res = await fetch(url.toString(), { cache: "no-store", method: "GET" });
    const data = (await res.json().catch(() => ({}))) as RabetCityCoordsResult;
    return data;
  } catch {
    return { ok: false, message: "Server error" };
  }
}
